/**
 * @http axios获取第三方接口数据
 * **/
import axios from 'axios'
import urls from './config'
import baseURL from './base'

// 定义axios基本设置
const request = axios.create({
  baseURL: baseURL
})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

// 错误统一处理
const createError = (code, resp) => {
  const err = new Error(resp.message)
  err.code = code
  return err
}

/**
 * @请求统一处理
 * **/
const handleRequest = ({status, data}) => {
  // store.commit("loadingMutation", false);
  if (status === 200) {
    return data
  } else {
    throw createError(status)
  }
}

export default () => {
  return {
    // 查询首页信息
    async getHomeList (pcMobile) {
      return handleRequest(await request.get(urls.tigrisso_home_list + pcMobile))
    },
    // tsTV列表
    async getTsTVList () {
      return handleRequest(await request.get(urls.tigrisso_tv_list))
    },
    // tsTV详情
    async getTsTVDetail (id) {
      return handleRequest(await request.get(urls.tigrisso_tv_detail + id))
    },
    // tsWorld列表
    async getTsWorldList () {
      return handleRequest(await request.get(urls.tigrisso_world_list))
    },
    // tsWorld详情
    async getTsWorldDetail (id) {
      return handleRequest(await request.get(urls.tigrisso_world_detail + id))
    },
    // 主推详情
    async getMainPushDetail (id) {
      return handleRequest(await request.get(urls.tigrisso_main_push_detail + id))
    },
    // 多元碰撞列表
    async getMultStockList (id) {
      return handleRequest(await request.get(urls.tigrisso_mult_shock_list + id))
    },
    // 多元碰撞详情
    async getMultStockDetail (id) {
      return handleRequest(await request.get(urls.tigrisso_mult_shock_detail + id))
    },
    // 主题系列列表
    async getThemeSeriesList (id) {
      return handleRequest(await request.get(urls.tigrisso_theme_list + id))
    },
    // 主题系列详情
    async getThemeSeriesDetail (id) {
      return handleRequest(await request.get(urls.tigrisso_theme_detail + id))
    },
    // 查询栏目查询列表
    async getColumnList (id) {
      return handleRequest(await request.get(urls.tigrisso_column_list + id))
    },
    // 商品查询
    async queryProductList (product) {
      return handleRequest(await request.post(urls.tigrisso_query_product, product))
    },
    // 查询栏目筛选条件
    async queryColumnCondiction (id) {
      return handleRequest(await request.get(urls.tigrisso_category_condiction + id))
    },
    // 商品详情
    async getProductDetail (id) {
      return handleRequest(await request.get(urls.tigrisso_product_detail + id))
    },
    // 查询省份
    async getProvince () {
      return handleRequest(await request.get(urls.tigrisso_query_province))
    },
    // 查询店铺列表
    async getShopList (id, currentPage, pageSize) {
      return handleRequest(await request.get(urls.tigrisso_shop_list + '/' + id + '/' + currentPage + '/' + pageSize))
    },
    // 查询附近店铺
    async getNearestShop (queryString) {
      return handleRequest(await request.get(urls.tigrisso_shop_nearestShop + queryString))
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js